export default __webpack_public_path__ + "img/6d2da24c87e6f8107becd7a1b1c2dba2.svg";